import {
  PAGO_NUBE_PROVIDER_NAME,
  NUVEM_PAGO_PROVIDER_NAME,
} from 'commons/constants';
import { isNuvemPagoProvider } from 'commons/utils';

export interface useNuvemPagoRedirectResponse {
  isNuvemPagoPayment: () => boolean;
  refundReceiptURL: (id: string) => string;
  partialRefundURL: (id: string) => string;
}

function useNuvemPagoRedirect(gateway: string): useNuvemPagoRedirectResponse {
  return {
    isNuvemPagoPayment: () => isNuvemPagoProvider(gateway || ''),
    refundReceiptURL: (id: string) => {
      if (gateway === PAGO_NUBE_PROVIDER_NAME) {
        return `/nuvempago/#/refund-receipt/${id}`;
      } else if (gateway === NUVEM_PAGO_PROVIDER_NAME) {
        return `/nuvempago#/transactions/${id}/refund-receipt?v=2`;
      } else {
        return '';
      }
    },
    partialRefundURL: (orderId: string) => {
      if (gateway === PAGO_NUBE_PROVIDER_NAME) {
        return `/admin/v2/nuvempago/#/refund/${orderId}`;
      } else if (gateway === NUVEM_PAGO_PROVIDER_NAME) {
        return `/admin/v2/nuvempago#/order-refund/${orderId}?v=2`;
      } else {
        return '';
      }
    },
  };
}

export default useNuvemPagoRedirect;
